import { Component, OnInit, NgZone } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { AlertController, ModalController } from '@ionic/angular';
import { DBService } from 'src/app/services/db.service';
import { QRScanInfoComponent } from 'src/app/components/qrscan-info/qrscan-info.component';
import { AlertService } from '../../../services/alert.service';
import { Router } from '@angular/router'
import { DeliveryArea } from 'src/app/models/delivery-area.model';

@Component({
  selector: 'app-edit-delivery-area',
  templateUrl: './edit-delivery-area.page.html',
  styleUrls: ['./edit-delivery-area.page.scss'],
})
export class EditDeliveryAreaPage implements OnInit {

  re = /[^-,0-9]/gi; 
  reDoubleComma = /[-,]{2,}/gi
  reLineStart = /^[-,]/gi;

  constructor(public db: DBService, public util: UtilService, private ngZone: NgZone, private router: Router,
    private alertCtrl: AlertController, private modalController: ModalController, private alert: AlertService) { }

  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }

  }

  cleanAmount(amount: string){
    if(this.util.hasEmptyFields([amount]))
      amount = "0"
    amount = amount.replace(".",",").replace(this.re,"").replace(this.reDoubleComma,",").replace(this.reLineStart,"").replace(".",",")
    return this.util.formatPrice(parseFloat(amount))
  }

  cleanAreaCodes(areaCodes: string){
    if(this.util.hasEmptyFields([areaCodes]))
      return undefined
    areaCodes = areaCodes.replace(this.re,"").replace(this.reDoubleComma,",").replace(this.reLineStart,"")
    return areaCodes
  }

  addDeliveryArea() {
    let deliveryArea: DeliveryArea = new DeliveryArea()
    this.db.currentRestaurant.deliveryAreas.push(deliveryArea)
    this.ngZone.run(() => console.log("force ui update"))
  }

  async deleteDeliveryArea(deliveryArea: DeliveryArea) {
    this.alert.presentAlertConfirm(this, (ref) => {
      ref.db.currentRestaurant.deliveryAreas = ref.util.deleteFromArray(ref.db.currentRestaurant.deliveryAreas, deliveryArea)
      ref.ngZone.run(() => console.log("force ui update"))
    }, 'Liefergebiet entfernen?', 'Möchtest du dieses Liefergebiet wirklich entfernen?')
  }

  back() {
    this.ngZone.run(() => this.router.navigate(['/owner-home']))
  }

  save() {
    let emptyAreas = []

    //Clean Format
    for(let i=0; i<this.db.currentRestaurant.deliveryAreas.length;i++){
      this.db.currentRestaurant.deliveryAreas[i].areaCodes = this.cleanAreaCodes(this.db.currentRestaurant.deliveryAreas[i].areaCodes)
      this.db.currentRestaurant.deliveryAreas[i].minAmount = this.cleanAmount(this.db.currentRestaurant.deliveryAreas[i].minAmount)

      if(this.util.hasEmptyFields([this.db.currentRestaurant.deliveryAreas[i].areaCodes]))
        emptyAreas.push(this.db.currentRestaurant.deliveryAreas[i])
    }

    //Delete areas which are empty now after cleaning
    for(let area2Delete of emptyAreas){
      this.db.currentRestaurant.deliveryAreas = this.util.deleteFromArray(this.db.currentRestaurant.deliveryAreas, area2Delete)
    }

    this.db.updateRestaurant(this.db.currentRestaurantKey)
    this.util.presentToast("Angaben wurden gespeichert")
    this.ngZone.run(() => {
      this.db.currentPage = 'home'
      this.router.navigate(['/owner-home'])
    })
  }


}
